var _linearGradient, _path, _linearGradient2, _polygon, _circle, _circle2, _circle3, _circle4, _linearGradient3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GoodPincode50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q6Ihoq9ZEAPCKQWRWaAmea",
    x1: 16.904,
    x2: 33.664,
    y1: 47.845,
    y2: 16.325,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q6Ihoq9ZEAPCKQWRWaAmea)",
    d: "M44.211,22H3.789C2.801,22,2,21.199,2,20.211V6.789C2,5.801,2.801,5,3.789,5h40.422 C45.199,5,46,5.801,46,6.789v13.422C46,21.199,45.199,22,44.211,22z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q6Ihoq9ZEAPCKQWRWaAmeb",
    x1: 19.346,
    x2: 29.122,
    y1: 43.253,
    y2: 24.866,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#q6Ihoq9ZEAPCKQWRWaAmeb)",
    points: "4,20 4,7 44,7 44,20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 13.5,
    r: 2.5,
    fill: "#107c42"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 13.5,
    r: 2.5,
    fill: "#107c42"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 13.5,
    r: 2.5,
    fill: "#107c42"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 13.5,
    r: 2.5,
    fill: "#107c42"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q6Ihoq9ZEAPCKQWRWaAmec",
    x1: 12,
    x2: 36,
    y1: 13.293,
    y2: 13.293,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q6Ihoq9ZEAPCKQWRWaAmec)",
    d: "M20.293,43.121l-8-8c-0.391-0.391-0.391-1.024,0-1.414l1.414-1.414 c0.391-0.391,1.024-0.391,1.414,0L21,38.172l11.879-11.879c0.391-0.391,1.024-0.391,1.414,0l1.414,1.414 c0.391,0.391,0.391,1.024,0,1.414l-14,14C21.317,43.512,20.683,43.512,20.293,43.121z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GoodPincode50);
export default __webpack_public_path__ + "static/media/icons8-good-pincode-50.ae1662b0675641ab46248e563b551805.svg";
export { ForwardRef as ReactComponent };